var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTweet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3167,
    cy: 25.0003,
    r: 20.8333,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8159 16.9883C36.8968 17.3966 35.9077 17.6716 34.8703 17.7958C35.9294 17.1608 36.7427 16.1559 37.1251 14.9585C36.1352 15.5468 35.0361 15.9726 33.8687 16.2034C32.9329 15.2068 31.5988 14.5835 30.1248 14.5835C27.2924 14.5835 24.9959 16.88 24.9959 19.7123C24.9959 20.114 25.0418 20.5056 25.1293 20.8814C20.8662 20.6681 17.0873 18.6257 14.5575 15.5226C14.1158 16.28 13.8633 17.1608 13.8633 18.1008C13.8633 19.8798 14.7675 21.4497 16.1449 22.3697C15.3033 22.343 14.5133 22.1122 13.8208 21.728V21.7922C13.8208 24.2779 15.5899 26.3502 17.9347 26.8227C17.5048 26.9393 17.0515 27.0027 16.584 27.0027C16.2532 27.0027 15.9315 26.9702 15.6182 26.9102C16.2707 28.9475 18.1656 30.4308 20.4096 30.4724C18.6547 31.8474 16.4432 32.6681 14.04 32.6681C13.625 32.6681 13.2167 32.644 12.8159 32.5956C15.0858 34.0505 17.7814 34.9005 20.6779 34.9005C30.1114 34.9005 35.2703 27.0852 35.2703 20.3081C35.2703 20.0856 35.2661 19.864 35.2553 19.6448C36.2585 18.9199 37.1285 18.0166 37.8159 16.9883Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTweet);
export default __webpack_public_path__ + "static/media/footerTweet.9c783e6d740eba8de4e65eab2eb5dd6b.svg";
export { ForwardRef as ReactComponent };